import React, { Component} from 'react'
import PropTypes from 'prop-types'
import PreferredLanguages from '../PreferredLanguages'
import { fetchLanguages } from './preferredLanguagesContainerActions'
import { connect } from 'react-redux'
import { preferredLanguageSelected } from '../searchCriteriaActions'
import Spinner from '../../../common/Spinners/Spinner'

class PreferredLanguagesContainer extends Component {
  static propTypes = {
    languages: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    preferredLanguageSelected: PropTypes.func.isRequired,
    selectedPreferredLanguageIds: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    validation: PropTypes.object.isRequired,
    showValidationErrors: PropTypes.bool.isRequired
  }

  constructor (props) {
    super(props)
    this.preferredLanguageSelected = this.preferredLanguageSelected.bind(this)
  }

  componentDidMount () {
    this.props.dispatch(fetchLanguages())
  }

  preferredLanguageSelected (languageId) {
    this.props.dispatch(this.props.preferredLanguageSelected(languageId))
  }

  render () {
    if (this.props.loading) {
      return <Spinner />
    }
    return <PreferredLanguages
      showValidationErrors={this.props.showValidationErrors}
      validation={this.props.validation}
      languages={this.props.languages}
      preferredLanguageSelected={this.preferredLanguageSelected}
      selectedPreferredLanguageIds={this.props.selectedPreferredLanguageIds}
    />
  }
}

const mapStateToProps = (state) => {
  return {
    languages: state.preferredLanguagesContainer.languages,
    selectedPreferredLanguageIds: state.findAnIfa.searchCriteria.selectedPreferredLanguageIds,
    loading: state.preferredLanguagesContainer.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    preferredLanguageSelected: preferredLanguageSelected,
    dispatch: dispatch,
    fetchLanguages: fetchLanguages
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferredLanguagesContainer)
